import React, { useEffect, useRef, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Input, Space, Spin } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest } from "../../axios";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import AssignedSiteEmployeeGrid from "./AssignedSiteEmployeeGrid";
import NewPrDetails from "./NewPrDetails";
import PurchaseRequisitionPdf from "./PurchaseRequisitionPdf";
import PurchaseDetailsinHistory from "./PurchaseDetailsInHistory";
import PurchaseRequisitionSteelDetails from "./PurchaseRequisitionSteelDetails";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const { Panel } = Collapse;

const PurchaseRequisitionDetails = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [material, setMaterial] = useState(null);

  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [isDownloading, setIsDownloading] = useState(false);
  const [purchaseRequisitionDetails, setPurchaseRequisitionDetails] = useState(
    []
  );
  const pdfContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [prNum, setPrNum] = useState(null);
  const buttonRef = useRef(null);
  const getPurchaseRequisitionDetails = async () => {
    setLoading(true);

    try {
      const fields = [
        "id",
        "pr_number",
        "pr_created_date",
        "category_tree_name",
        "pr_type",
        "city_site_material_data",
      ].join(",");
      const queryParams = new URLSearchParams();
      queryParams.set("fields", fields);
      let apiResponse = await getRequest(
        `purchase-requisition/${id}/?${queryParams.toString()}`
      );

      if (apiResponse.data.data) {
        setPurchaseRequisitionDetails(apiResponse.data.data);
        setPrNum(apiResponse.data.data.pr_number);
        setMaterial(apiResponse.data.data.pr_type);
      } else {
        ErrorNotificationMsg(t("error_in_purchase_requisition"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getPurchaseRequisitionDetails();
  }, []);

  const data = [];
  for (let i = 0; i < 3; ++i) {
    data.push({
      key: i.toString(),
      name: "Screen",
      platform: "iOS",
      version: "10.3.4.5654",
      upgradeNum: 500,
      creator: "Jack",
      createdAt: "2014-12-24 23:12:00",
    });
  }

  const renderTables = () => {
    if (!purchaseRequisitionDetails.purchase_requisition_details) return null;
    const groupedDetails = {};
    let totalAmount = 0;
    purchaseRequisitionDetails.purchase_requisition_details.forEach(
      (detail) => {
        const subCategory = detail.sub_category;
        if (!groupedDetails[subCategory]) {
          groupedDetails[subCategory] = { sites: {}, details: [] };
        }
        groupedDetails[subCategory].details.push(detail);
        detail.site_wise?.forEach((site) => {
          groupedDetails[subCategory].sites[site.site_name] = true;
        });
      }
    );

    return Object.entries(groupedDetails).map(
      ([subCategory, { sites, details }], index) => {
        const siteNames = Object.keys(sites);
        const site_wise = Object.keys(sites);

        let customSubcategory = "";

        if (subCategory === "SPECIAL CEMENT") {
          customSubcategory = "Special Cement";
        } else {
          customSubcategory = subCategory;
        }
        const data = [];

        let amount = 1;

        details.map((detail, index) => {
          if (detail.unit_of_measurement_name === "Cum.") {
            amount =
              // 1000 *
              detail.total_quantity *
              detail.sand_conversion *
              detail.estimated_material_unit_price;
          } else if (detail.unit_of_measurement_name === "MT") {
            amount =
              1000 *
              (detail.total_quantity * detail.estimated_material_unit_price);
          } else if (detail.unit_of_measurement_name === "Bag") {
            amount =
              50 *
              (detail.total_quantity * detail.estimated_material_unit_price);
          } else if (detail.unit_of_measurement_name === "Cubic Meter") {
            amount =
              detail.total_quantity * detail.estimated_material_unit_price;
          }

          totalAmount += amount;

          data.push({
            ...detail,
            srNo: index,
            key: detail.pr_details_id?.toString(),
            totalQuantity: `${detail.total_quantity} ${detail.unit_of_measurement_name}`,
            remark: detail.remark,
            estimatedAmount: amount,
          });
        });
        const siteNameColumns = siteNames.map((site, index) => ({
          title: site,
          dataIndex: index,
          key: index,
          width: 80,
        }));

        const siteWiseColumns = site_wise.map((site, siteIndex) => ({
          title: "Site Input",
          dataIndex: `siteInput_${siteIndex}`,
          key: `siteInput_${siteIndex}`,
          width: 80,
          render: (text, record) => {
            const matchingSite = record.site_wise.find(
              (s) => s.site_name === site
            );
            if (matchingSite) {
              return (
                <div className="lblvalue" style={{ marginLeft: "5px" }}>
                  {matchingSite?.quantity}
                </div>
              );
            }
            return null;
          },
        }));

        const columns1 = [
          {
            title: `${index + 1}`,
            dataIndex: "srNo",
            key: "1",
            width: 50,
            render: (text, record, ind) => `${index + 1}.${ind + 1}`,
          },
          {
            title: `${customSubcategory}`,
            dataIndex: `${subCategory}`,
            key: `${subCategory}`,
            width: "140px",
            render: (text, record) => {
              return (
                <>
                  {record.site_wise.map((site, siteIndex) => (
                    <Input readOnly key={siteIndex} value={site.quantity} />
                  ))}
                </>
              );
            },
          },
          ...siteNameColumns,
          {
            title: "Total Qty.",
            dataIndex: "TOTAL",
            key: "8",
            width: 100,
            align: "right",
          },
          {
            title: "UoM.",
            dataIndex: "UOM",
            key: "7",
            width: 80,
            render: (text, record) => {
              // return text === "Cubic Meter" ? "Cu. Mtr." : text
            },
          },

          {
            title: "Total Qty. in Kg",
            dataIndex: "Total Kilogram",
            key: "8",
            width: 150,
            align: "right",
          },
          {
            title: "Est. Amount",
            dataIndex: "Total Kilogram",
            key: "9",
            width: 150,
            align: "right",
          },
          {
            title: "Remarks",
            dataIndex: "Remark",
            key: "3",
          },
        ];

        const thead = <Table columns={columns1} />;

        return (
          <Collapse
            key={index.toString()}
            defaultActiveKey={[index.toString()]}
          >
            <Panel key={index.toString()} header={thead}>
              <Table
                columns={[
                  // ...columns,
                  {
                    title: `${index + 1}`,
                    dataIndex: "srNo",
                    key: "1",
                    width: 50,
                    render: (text, record, ind) => `${index + 1}.${ind + 1}`,
                  },
                  {
                    title: "Type Name",
                    dataIndex: "material_type_name_by_company",
                    key: "material_type_name_by_company",
                    width: "160px",
                  },

                  ...siteWiseColumns,
                  {
                    title: "Total Quantity",
                    dataIndex: "totalQuantity",
                    key: "totalQuantity",
                    width: 100,
                    align: "right",
                    render: (text, record) => (
                      <div
                        className="lblvalue"
                        style={{
                          marginLeft: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        {record.total_quantity?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}
                      </div>
                    ),
                  },
                  {
                    title: "UOM",
                    dataIndex: "unit_of_measurement",
                    key: "unit_of_measurement",
                    width: 80,
                    render: (text, record) => {
                      return (
                        <div className="lblvalue" style={{ marginLeft: "0px" }}>
                          {record.unit_of_measurement_name === "Cubic Meter"
                            ? "Cu. Mtr."
                            : record.unit_of_measurement_name}
                          {/* {record?.unit_of_measurement === 4
                            ? "Cu. Mtr."
                            : record?.unit_of_measurement_name} */}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Qty In Kg",
                    dataIndex: "total_quantity_by_kg",
                    key: "total_quantity_by_kg",
                    width: 150,
                    align: "right",
                    render: (text, record) => {
                      return (
                        <div
                          className="lblvalue"
                          style={{
                            marginLeft: "5px",
                            justifyContent: "flex-end",
                          }}
                        >
                          {record.total_quantity_by_kg == 0
                            ? "-"
                            : record.total_quantity_by_kg?.toLocaleString(
                                "en-IN",
                                {
                                  maximumFractionDigits: 0,
                                }
                              )}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Est. Amount",
                    dataIndex: "total_quantity",
                    key: "total_quantity",
                    width: 150,
                    align: "right",
                    render: (text, record) => {
                      let amount = 1;
                      if (record.unit_of_measurement_name === "Cum.") {
                        amount =
                          1000 *
                          (record.total_quantity *
                            record.sand_conversion *
                            record.estimated_material_unit_price);
                      } else if (record.unit_of_measurement_name === "MT") {
                        amount =
                          1000 *
                          (record.total_quantity *
                            record.estimated_material_unit_price);
                      } else if (record.unit_of_measurement_name === "Bag") {
                        amount =
                          50 *
                          (record.total_quantity *
                            record.estimated_material_unit_price);
                      } else if (
                        record.unit_of_measurement_name === "Cubic Meter"
                      ) {
                        amount =
                          record.total_quantity *
                          record.estimated_material_unit_price;
                      }
                      return (
                        <div
                          className="lblvalue"
                          style={{
                            marginLeft: "5px",
                            justifyContent: "flex-end",
                          }}
                        >
                          ₹{" "}
                          {amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Remark",
                    dataIndex: "remark",
                    key: "remark",
                    render: (text, record) => {
                      return <span>{record.remark}</span>;
                    },
                  },
                ]}
                dataSource={data}
                pagination={false}
                scroll={{ x: "auto" }}
              />
            </Panel>
          </Collapse>
        );
      }
    );
  };

  return (
    <>
      {/* <Spin spinning={loading}> */}
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Purchase Requisition (PR) - Details</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/purchase-requisition-history">
                  Purchase Requisition History
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Purchase Requisition Details</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="btnscol">
            <Space>
              <PurchaseRequisitionPdf
                pdfContainerRef={pdfContainerRef}
                prNumber={prNum}
                buttonRef={buttonRef}
                setIsDownloading={setIsDownloading}
              />
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="Back"
                label="Back"
                onClick={() => navigate("/purchase-requisition-history")}
              />
            </Space>
          </div>
        </div>
      </div>
      <section className="grid-sec mt-5 multitable" ref={pdfContainerRef}>
        <SubscriptionNotification />
        <div className="PR-body tbl-collapse" style={{ padding: "0" }}>
          <div className="filterrow">
            <div className="filtercol">
              <Space wrap>
                <div className="lblwrp">
                  <label>PR Number</label>
                  <h6> {purchaseRequisitionDetails.pr_number}</h6>
                </div>
                <div className="lblwrp">
                  <label>PR Created Date</label>
                  <h6>{purchaseRequisitionDetails.pr_created_date}</h6>
                </div>
                <div className="lblwrp">
                  <label>Category</label>
                  <h6>{purchaseRequisitionDetails.category_tree_name}</h6>
                </div>
              </Space>
            </div>
          </div>
          <div className="tablewrp">
            <Spin spinning={loading}>
              <Collapse defaultActiveKey={["0"]} className="scroll3">
                {purchaseRequisitionDetails.category_tree_name
                  ?.toLowerCase()
                  .includes("steel") ? (
                  <PurchaseRequisitionSteelDetails
                    prData={purchaseRequisitionDetails}
                  />
                ) : material === "City Wise" ? (
                  <PurchaseDetailsinHistory PRid={id} />
                ) : (
                  renderTables()
                )}
              </Collapse>

              <AssignedSiteEmployeeGrid prId={id} ref={pdfContainerRef} />
            </Spin>
          </div>

          <div className="btnwrp">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="Back"
              label="Back"
              onClick={() => navigate("/purchase-requisition-history")}
            />
          </div>
        </div>
      </section>
      {/* </Spin> */}
    </>
  );
};
export default PurchaseRequisitionDetails;
